import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import React from "react";
import { useRecoilValue } from "recoil";
import { billingAtom } from "../store/billingAtom";
import Modal from "./Modal";

export default function DowngradePlanModal({
  open,
  onClose,
  onSubmit,
  loading,
  selectedPlan,
}) {
  const billingInfo = useRecoilValue(billingAtom);

  const getPeriod = () => {
    if (selectedPlan?.type === "annually") return "year";
    else if (selectedPlan?.type === "monthly") return "month";
    return "N/A";
  };

  const period = getPeriod();

  const cycleEndAt = billingInfo?.next_renewal || "N/A";

  return (
    <Modal
      startIcon={
        <ExclamationCircleIcon
          aria-hidden="true"
          className="size-8 text-amber-600"
        />
      }
      title="Downgrade Subscription"
      description={
        <div>
          <p className="text-sm text-gray-500">
            By clicking <span className="font-semibold">Downgrade</span>, you
            will subscribe to the{" "}
            <span className="font-semibold">
              {selectedPlan?.name || "N/A"} plan
            </span>{" "}
            for ${selectedPlan?.cost || "N/A"} per {period}.
          </p>

          <p className="text-sm text-gray-500">
            Your plan will continue on the{" "}
            <span className="font-semibold">
              {billingInfo?.active_plan?.payment_plan?.name || "N/A"} plan
            </span>{" "}
            until the end of your billing cycle on {cycleEndAt} and then you
            will be <span className="font-semibold">Downgraded</span> on your
            next billing cycle.
          </p>
        </div>
      }
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      isSubmitting={loading}
    />
  );
}
